<template>
  <a-drawer
    title="订单详情"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="visible=false"
    width="450"
  >
    <a-form-model
      ref="form"
      :model="formData"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <!-- <div class="form-title">基本信息</div> -->
      <a-form-model-item label="订单号">
        {{ formData.orderId }}
      </a-form-model-item>
      <a-form-model-item label="企业简称">
        {{ formData.tenant_name }}
      </a-form-model-item>
      <a-form-model-item label="联系人名称">
        {{ formData.contacts }}
      </a-form-model-item>
      <a-form-model-item label="联系人电话">
        {{ formData.contact_number }}
      </a-form-model-item>
      <a-form-model-item label="状态">
        <a-tag :color="formData.status | statusTagFilter">
          {{ formData.status | valInDict(dict.statusDict) }}
        </a-tag>
      </a-form-model-item>
      <a-form-model-item
        v-if="orderType === 'RECHARGE'"
        label="云码数量"
      >
        {{ formData.security_code_count }}
      </a-form-model-item>
      <a-form-model-item
        v-if="orderType === 'ANNUAL'"
        label="续费年限"
      >
        {{ formData.type | valInDict(dict.typeDict) }}
      </a-form-model-item>
      <a-form-model-item label="订单金额">
        {{ formData.total_price }} 元
      </a-form-model-item>
      <a-form-model-item label="支付方式">
        {{ formData.pay_type | valInDict(dict.payTypeDict) }}
      </a-form-model-item>
      <a-form-model-item label="最后更新时间">
        {{ formData.update_time }}
      </a-form-model-item>
      <a-form-model-item label="创建时间">
        {{ formData.create_time }}
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { deepClone } from '@/utils'
import { getOrderPre, getRechargeOrderDetail, getAnnualOrderDetail } from '@/api/print'

export default {
  data() {
    return {
      orderId: '',
      orderType: '',
      visible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      formData: {},
      dict: {
        payTypeDict: [],
        statusDict: [],
        typeDict: [{ id: 'NORMAL', name: '买码会员1年' }, { id: 'FOREVER', name: '无限码会员1年' }]
      }
    }
  },
  props: {},
  watch: {},
  methods: {
    showModal(orderId, orderType) {
      this.orderId = orderId
      this.orderType = orderType
      this.visible = true
      this.getPre()
      this.getDetail()
    },
    // 预加载
    getPre() {
      getOrderPre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.dict.payTypeDict = data.payTypeDict
            this.dict.statusDict = data.statusDict
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    },
    getDetail() {
      if (this.orderType === 'RECHARGE') {
        this.getRechargeOrderDetail()
      }
      if (this.orderType === 'ANNUAL') {
        this.getAnnualOrderDetail()
      }
    },
    // 充值订单详情
    getRechargeOrderDetail() {
      getRechargeOrderDetail({
        orderId: this.orderId
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.formData = deepClone(data)
          }
        })
        .catch((e) => {
          this.$message.error('请求充值订单详情失败')
        })
    },
    // 年费订单详情
    getAnnualOrderDetail() {
      getAnnualOrderDetail({
        orderId: this.orderId
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.formData = deepClone(data)
          }
        })
        .catch((e) => {
          this.$message.error('请求年费订单详情失败')
        })
    }
  }
}
</script>
<style lang="less">
.qrcode {
  width: 200px;
  height: 200px;
  background-color: #eee;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .loading {
    position: absolute;
    top: 0;
    left: 0;
  }
  .fresh-qrcode-btn {
    position: absolute;
    right: -50px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.money {
  text-align: center;
  font-size: 18px;
  margin: 10px 0;
}
.red {
  color: red;
}
.fw-b {
  font-weight: bolder;
}
</style>
